import React from 'react';
import ReactDOM from 'react-dom/client';
import Routers from './core/components/Routers/Index';

import './assets/css/index.css';
import './assets/css/product.css';
import './assets/css/button-success.css';
import './assets/css/input-material.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Routers />
  </React.StrictMode>,
  document.getElementById('root')
);